<template>
  <div class="footer-cont ma-0">
    <v-container
      class="pa-0"
    >
      <v-row
        align="center"
        class="ma-0 pa-0"
      >
        <v-col
          class="text-right"
        >
          <div class="pt-1">
            <a class="footer-link"
            href="//www.kmkey.com/nosotros/">{{ $vuetify.lang.translator('footer.contact') }}</a>
          </div>
        </v-col>

        <v-col
          md="auto"
          class="ma-0 pa-0"
        >
          <v-img
            contain
            class="footer-icon"
            :src="qmkey_icon"
          />
        </v-col>

        <v-col
          class="text-left"
        >
          <div class="pt-1">
            <a class="footer-link"
            href="//www.youtube.com/c/KMKeyManager">{{ $vuetify.lang.translator('footer.help') }}</a>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div class="footer-copyright">
      © 2002 - {{ new Date().getFullYear() }} Earcon S.L. Sant Boi de Llobregat
    </div>
  </div>
</template>

<script>
 import customThemes from '@/plugins/themes.js'
 import { mapState } from 'vuex'

 export default {
   name: "Footer",
   computed: {
     ...mapState(['currentTheme']),
     qmkey_icon() {
       return (customThemes[this.currentTheme] || {}).logo || customThemes.logo;
     },
   }
 };
</script>

<style lang="scss">
 @import "@/sass/footer.scss";
</style>
